export default (userId: string) => {
    try {
        if(typeof window.gtag !== 'function') {
            return
        }
        window.gtag('config', globalThis.config.GA4Property, { 'user_id' : userId })
    } catch(error) {
        console.error(error)
    }
}